import { render, staticRenderFns } from "./modal_paraphrase.vue?vue&type=template&id=3c932b4b&"
import script from "./modal_paraphrase.vue?vue&type=script&lang=js&"
export * from "./modal_paraphrase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports